// extracted by mini-css-extract-plugin
module.exports = {"bottom-buttom":"PressToNext_bottom-buttom__2odnj","button":"PressToNext_button__3p1KA","button-to-next-chapter":"PressToNext_button-to-next-chapter__33Ksx"};